import styled from 'styled-components'
import above from '@/utils/above'
import getColumnSize from '@/utils/getColumnSize'
import * as UI from '@/components/UI'

export const Section = styled.section`
  color: ${p => p.theme.colors.maastricht};
  padding: 6rem 0;
  ${above('lg')`
    padding-top: 12rem;
  `}
`

export const Grid = styled(UI.Grid)``

export const BodyCell = styled.div`
  width: ${getColumnSize(12)};
  ${above('md')`
    width: ${getColumnSize(6)};
  `}
  ${above('lg')`
    width: ${getColumnSize(5)};
    margin-right: ${getColumnSize(1)};
  `}
  ${above('xg')`
    margin-left: ${getColumnSize(1)};
  `}
`

export const Title = styled(UI.Subtitle)`
  font-family: ${p => p.theme.type.fonts.headline};
  font-weight: 500;
  margin-bottom: 1.5rem;
`

export const Body = styled(UI.Text).attrs({ as: 'div' })`
  color: ${p => p.theme.colors.gray};
`

export const SidebarCell = styled.div`
  width: ${getColumnSize(12)};
  position: relative;
  ${above('md')`
    width: ${getColumnSize(6)};
  `}
  ${above('xg')`
    width: ${getColumnSize(5)};
  `}
`

export const WrapperSidebarCell = styled.div`
  width: ${getColumnSize(12)};
  position: relative;
  ${above('md')`
  width: ${getColumnSize(6)};
`}
  ${above('xg')`
  width: ${getColumnSize(5)};
`}
`

export const Sidebar = styled.div`
  margin-top: 5rem;
  padding: 1.25rem 1.5rem 1.5rem;
  background: ${p => p.theme.colors.flash};
  ${above('md')`
    margin-top: 4rem;
  `}
`

export const SidebarTitle = styled(UI.SmallText).attrs({ as: 'h3' })`
  font-family: ${p => p.theme.type.fonts.headline};
  margin-bottom: 1.75rem;
`

export const List = styled.ul``

export const Item = styled(UI.SmallText).attrs({ as: 'li' })`
  margin-top: 1rem;
  display: flex;
  position: relative;
  color: inherit;
  &:before {
    content: '—';
    color: ${p => p.theme.colors[p.color]};
    margin-right: 0.5rem;
  }
`
